import appGlobalScript from '/builds/sydle/sydle-ui/packages/ui-design-system/src/global/setup.ts';
export const globalScripts = appGlobalScript;
